import React from "react";
import "./ItemBulkDownload.scss";
import { CSVLink } from "react-csv";
import { REMOTE_BASE_URL } from "../../../../constants";

export default function ItemBulkDownload({ records, onDownload }) {
	const getData = records.map(record => {
		const mediaByType = { image: [], video: [] };
		const copy = Object.assign({}, record);
		record.media.forEach(media => {
			copy[media.type + '_' + mediaByType[media.type].length] = REMOTE_BASE_URL + media.source;
			mediaByType[media.type].push(true);
		});
		delete copy.media;
		Object.keys(copy).forEach(key => (key.indexOf('data:') === 0) && (delete copy[key]));
		return copy;
	});

	const getFilename = () => document.title.toString().replace(/ | /g, '').trim() + '.csv';

	return (
		<CSVLink filename={getFilename()} className="item-bulk-download" data={getData}>
			<button className="btn download" onClick={onDownload}>Download Items</button>
		</CSVLink>
	);
}
